export default {
  functionKey: "REGEXREPLACE",
  title: "REGEXREPLACE",
  group: "Texte",
  origin: [],
  target: [],
  arguments: [],
  maxArguments: 3,
  requiredArguments: [
    { argumentKey: "Pattern",     name: "Expression régulière" },
    { argumentKey: "Replacement", name: "Texte de remplacement", empty: true },
    { argumentKey: "Flags",       name: "Options (ex: i, g...)", empty: true }
  ],
  expectedArguments: [
    { name: "Expression régulière",       argumentKey: "Pattern",     single: true, initialValue: "" },
    { name: "Texte de remplacement",      argumentKey: "Replacement", single: true, initialValue: "''", empty: true },
    { name: "Options (ex: i, g...)",      argumentKey: "Flags",       single: true, initialValue: "g", empty: true }
  ],
  description: "Remplace les correspondances d'une regex. (Ex: REGEXREPLACE(valeur, '[0-9]+', '#', 'g') -> 'prix: #€')",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const pattern     = args[0] ?? "''";
    const replacement = args[1] ?? "''";
    const flags       = args[2] ?? "'g'";
    const code = `${destination} = ${origin}.replace(new RegExp(${pattern}, ${flags}), ${replacement});`;
    return { displayCode: code, safeCode: code };
  }
}
